/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantSearchDetailsFilter } from '../../models/merchant-search-details-filter';
import { PageMerchantSearchResponse } from '../../models/page-merchant-search-response';

export interface SearchMerchant$Params {

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
      body: MerchantSearchDetailsFilter
}

export function searchMerchant(http: HttpClient, rootUrl: string, params: SearchMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<PageMerchantSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchMerchant.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageMerchantSearchResponse>;
    })
  );
}

searchMerchant.PATH = '/merchants/search-by-segments';
